import { Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Subject, Observable, of } from "rxjs";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { AnyNaptrRecord } from "dns";
import { AuthService } from "../auth/authServices";
import { ConfigService } from "src/app/services/config.service";
export interface InterpreterResponse {
  data: any[];
  total: number;
  currentPage: number;
  totalPages: number;
}

@Injectable({
  providedIn: "root",
})
export class AttorneyAndInsuranceService {
  private data: any[] = [];
  private dataUpdate = new Subject<{ data: any[] }>();

  private data2: any[] = [];
  private dataUpdate2 = new Subject<{ data: any[] }>();

  private data3: any[] = [];
  private dataUpdate3 = new Subject<{ data: any[] }>();

  private data4: any[] = [];
  private dataUpdate4 = new Subject<{ data: any[] }>();

  BACKEND_URL: string;

  constructor(private http: HttpClient, private Auth: AuthService, private configService: ConfigService) {
    this.BACKEND_URL = this.configService.get('apiUrl') + '/admin';
  }
  roleName = this.Auth.getRoleName();
  roleQuery = this.roleName
    ? `&roleName=${encodeURIComponent(this.roleName)}`
    : "";

  // getAllAttorney(name: string, active: any, attorneyType: any) {
  //   this.http
  //     .get<{ message: string; data: any }>(
  //       `${this.BACKEND_URL}/getAllAttorney?name=${name}&active=${active}&attorneyType=${attorneyType}${this.roleQuery}`
  //     )
  //     .pipe(
  //       map((Data) => {
  //         return {
  //           data: Data.data.map((data) => {
  //             return data;
  //           }),
  //         };
  //       })
  //     )
  //     .subscribe((transformedData) => {
  //       this.data = transformedData.data;
  //       this.dataUpdate.next({
  //         data: [...this.data],
  //       });
  //     });
  // }

  //   getAllAttorney(name: string, search: any, active: string, attorneyType: string) {
  //   let query = "";

  //   if (search && search.trim() !== "") {
  //     query += `&search=${encodeURIComponent(search.trim())}`;
  //   }

  //   if (active === "true" || active === "false") {
  //     query += `&active=${active}`;
  //   }

  //   if (attorneyType && attorneyType !== "View All") {
  //     query += `&attorneyType=${encodeURIComponent(attorneyType)}`;
  //   }

  //   this.http
  //     .get<{ message: string; data: any }>(
  //       `${this.BACKEND_URL}/getAllAttorney?name=${name}${query}${this.roleQuery}`
  //     )
  //     .pipe(
  //       map((Data) => ({
  //         data: Data.data,
  //       }))
  //     )
  //     .subscribe((transformedData) => {
  //       this.data = transformedData.data;
  //       this.dataUpdate.next({
  //         data: [...this.data],
  //       });
  //     });
  // }

  getAllAttorney(
    name: string,
    search: any,
    active: string,
    attorneyType: string,
    page: number,
    limit: number,
    sortColumn: string = "",
    sortDirection: "asc" | "desc" | "" = ""
  ) {
    let activeQuery = "";
    let searchQuery = "";
    let typeQuery = "";
    let sortQuery = "";

if (typeof active === "string") {
      const trimmed = active.trim().toLowerCase();
      if (trimmed === "activate") activeQuery = `&active=true`;
      else if (trimmed === "deactivate") activeQuery = `&active=false`;
      else if (trimmed === "true" || trimmed === "false")
        activeQuery = `&active=${trimmed}`;
    } else if (typeof active === "boolean") {
      activeQuery = `&active=${active}`;
    }

    if (attorneyType && attorneyType !== "View All") {
      typeQuery += `&attorneyType=${encodeURIComponent(attorneyType)}`;
    }

    if (search && search.trim()) {
      searchQuery = `&search=${encodeURIComponent(search.trim())}`;
    }

    if (sortColumn && sortDirection) {
      sortQuery = `&sortColumn=${sortColumn}&sortDirection=${sortDirection}`;
    }

    return this.http
      .get<{
        status?: string;
        data: any[];
        total?: number;
        currentPage?: number;
        totalPages?: number;
      }>(
        `${this.BACKEND_URL}/getAllAttorney?name=${name}${activeQuery}${typeQuery}${searchQuery}${this.roleQuery}&page=${page}&limit=${limit}${sortQuery}`
      )
      .pipe(
        map((response) => ({
          data: Array.isArray(response.data) ? response.data : [],
          total: response.total ?? 0,
          currentPage: response.currentPage ?? page,
          totalPages: response.totalPages ?? 1,
        }))
      );
  }

  //   getAllAttorney(name: string, filter: any, attorneyType: string) {
  //   let query = "";

  //   if (typeof filter === "string") {
  //     const trimmed = filter.trim().toLowerCase();
  //     if (trimmed === "true" || trimmed === "false") {
  //       query += `&active=${trimmed}`;
  //     } else if (trimmed !== "") {
  //       query += `&search=${encodeURIComponent(trimmed)}`;
  //     }
  //   } else if (typeof filter === "boolean") {
  //     query += `&active=${filter}`;
  //   }

  //   if (attorneyType && attorneyType !== "View All") {
  //     query += `&attorneyType=${encodeURIComponent(attorneyType)}`;
  //   }

  //   this.http
  //     .get<{ message: string; data: any }>(
  //       `${this.BACKEND_URL}/getAllAttorney?name=${name}${query}${this.roleQuery}`
  //     )
  //     .pipe(
  //       map((Data) => ({
  //         data: Data.data,
  //       }))
  //     )
  //     .subscribe((transformedData) => {
  //       this.data = transformedData.data;
  //       this.dataUpdate.next({
  //         data: [...this.data],
  //       });
  //     });
  // }

  getUpdateListener() {
    return this.dataUpdate.asObservable();
  }

  addAttorney(data: any): Observable<{ message: string; data: any }> {
    return this.http.post<{ message: string; data: any }>(
      this.BACKEND_URL + `/create_attorney?name=Add Attorney${this.roleQuery}`,
      data
    );
  }

  editAttorney(
    data: any,
    id: string
  ): Observable<{ message: string; data: any }> {
    return this.http.post<{ message: string; data: any }>(
      this.BACKEND_URL +
        "/update_attorney/" +
        id +
        `?name=Update Attorney${this.roleQuery}`,
      data
    );
  }

  deleteAttorney(id: string): Observable<any> {
    return this.http.post<{ status: any; message: AnyNaptrRecord }>(
      `${this.BACKEND_URL}/deleteAttroney/${id}?name=Delete Attorney${this.roleQuery}`,
      {}
    );
  }

  active_deactiveAttorney(id: string, active: any): Observable<any> {
    return this.http.post<{ status: any; message: AnyNaptrRecord }>(
      `${this.BACKEND_URL}/activeDeactiveAttorney/${id}?name=Active Attorney${this.roleQuery}`,
      { active }
    );
  }

  // Insurance API Service

 getAllInsurance(
    name: string,
    active: boolean | null,
    searchText: string = '',
    page: number = 1,
    limit: number = 20,
    sortColumn: string = '',
    sortDirection: string = ''
  ): Observable<{ data: any[] }> {
    let queryParams = `?name=${encodeURIComponent(name)}&page=${page}&limit=${limit}`;

    if (typeof active === 'boolean') {
      queryParams += `&active=${active}`;
    }

    if (searchText.trim() !== '') {
      queryParams += `&search=${encodeURIComponent(searchText.trim())}`;
    }

    if (sortColumn && sortDirection) {
      queryParams += `&sortColumn=${encodeURIComponent(sortColumn)}&sortDirection=${encodeURIComponent(sortDirection)}`;
    }

    return this.http
      .get<{ message: string; data: any[] }>(
        `${this.BACKEND_URL}/getAllInsurance${queryParams}${this.roleQuery}`
      )
      .pipe(
        map((response) => ({
          data: response.data
        }))
      );
  }

  // getAllInsurance(
  //   name: string,
  //   active: boolean | null,
  //   searchText: string = ""
  // ) {
  //   let queryParams = `?name=${encodeURIComponent(name)}`;

  //   if (typeof active === "boolean") {
  //     queryParams += `&active=${active}`;
  //   }

  //   if (searchText.trim() !== "") {
  //     queryParams += `&search=${encodeURIComponent(searchText.trim())}`;
  //   }

  //   this.http
  //     .get<{ message: string; data: any }>(
  //       `${this.BACKEND_URL}/getAllInsurance${queryParams}${this.roleQuery}`
  //     )
  //     .pipe(
  //       map((Data) => ({
  //         data: Data.data,
  //       }))
  //     )
  //     .subscribe((transformedData) => {
  //       this.data2 = transformedData.data;
  //       this.dataUpdate2.next({
  //         data: [...this.data2],
  //       });
  //     });
  // }

  getUpdateListener2() {
    return this.dataUpdate2.asObservable();
  }

  addInsurance(data: any): Observable<{ message: string; data: any }> {
    return this.http.post<{ message: string; data: any }>(
      this.BACKEND_URL + `/create_insurance?name=Add Insurance${this.roleQuery}`,
      data
    );
  }

  editInsurance(
    data: any,
    id: string
  ): Observable<{ message: string; data: any }> {
    return this.http.post<{ message: string; data: any }>(
      this.BACKEND_URL +
        "/update_insurance/" +
        id +
        `?name=Update Insurance${this.roleQuery}`,
      data
    );
  }

  deleteInsurance(id: string): Observable<any> {
    return this.http.post<{ status: any; message: AnyNaptrRecord }>(
      `${this.BACKEND_URL}/deleteInsurance/${id}?name=Delete Insurance${this.roleQuery}`,
      {}
    );
  }

  active_deactiveInsurance(id: string, active: any): Observable<any> {
    return this.http.post<{ status: any; message: AnyNaptrRecord }>(
      `${this.BACKEND_URL}/activeDeactiveInsurance/${id}?name=Active Insurance${this.roleQuery}`,
      { active }
    );
  }

  // Interpreter API Service

  // getAllInterpreter(name: string, active: any, language: any) {
  //   this.http
  //     .get<{ message: string; data: any }>(
  //       `${this.BACKEND_URL}/getAllInterpreter?name=${name}&active=${active}&language=${language}${this.roleQuery}`
  //     )
  //     .pipe(
  //       map((Data) => {
  //         return {
  //           data: Data.data.map((data) => {
  //             return data;
  //           }),
  //         };
  //       })
  //     )
  //     .subscribe((transformedData) => {
  //       this.data3 = transformedData.data;
  //       this.dataUpdate3.next({
  //         data: [...this.data3],
  //       });
  //     });
  // }

  getAllInterpreter(
    name: string,
    activeFilter: string,
    language: string,
    search: string = '',
    page: number = 1,
    limit: number = 10,
    sortColumn: string = 'createdAt',
    sortDirection: string = 'desc'
  ): Observable<InterpreterResponse> {
    let url = `${this.BACKEND_URL}/getAllInterpreter?name=${name}&active=${activeFilter}&language=${language}&${this.roleQuery}`;
    url += `&page=${page}&limit=${limit}`;
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
    if (sortColumn && sortDirection) {
      url += `&sortColumn=${encodeURIComponent(sortColumn)}&sortDirection=${sortDirection}`;
    }

    return this.http.get<{ message: string; total: number; currentPage: number; totalPages: number; data: any[] }>(url).pipe(
      map((response) => {
        this.data3 = response.data;
        const transformedResponse: InterpreterResponse = {
          data: [...this.data3],
          total: response.total,
          currentPage: response.currentPage,
          totalPages: response.totalPages
        };
        this.dataUpdate3.next(transformedResponse);
        return transformedResponse;
      })
    );
  }
  getUpdateListener3() {
    return this.dataUpdate3.asObservable();
  }

  addInterpreter(data: any): Observable<{ message: string; data: any }> {
    return this.http.post<{ message: string; data: any }>(
      this.BACKEND_URL + `/createInterpreter?name=Add Interpreter${this.roleQuery}`,
      data
    );
  }

  editInterpreter(
    data: any,
    id: string
  ): Observable<{ message: string; data: any }> {
    return this.http.post<{ message: string; data: any }>(
      this.BACKEND_URL +
        "/updateInterpreter/" +
        id +
        `?name=Update Interpreter${this.roleQuery}`,
      data
    );
  }

  deleteInterpreter(id: string): Observable<any> {
    return this.http.post<{ status: any; message: AnyNaptrRecord }>(
      `${this.BACKEND_URL}/deleteInterpreter/${id}?name=Delete Interpreter${this.roleQuery}`,
      {}
    );
  }

  active_deactiveInterpreter(id: string, active: any): Observable<any> {
    return this.http.post<{ status: any; message: AnyNaptrRecord }>(
      `${this.BACKEND_URL}/activeDeactiveInterpreter/${id}?name=Active Interpreter${this.roleQuery}`,
      { active }
    );
  }


  getAllApplicants(
    name: string,
    active: any,
    search: string,
    page: number,
    limit: number,
    sortColumn: string = "",
    sortDirection: "asc" | "desc" | "" = "",
    partyRecordType: "applicant" | "plaintiff" | "all" = "all"
  ) {
    let activeQuery = "";
    let searchQuery = "";
    let sortQuery = "";
    if (typeof active === "string") {
      const trimmed = active.trim().toLowerCase();
      if (trimmed === "activate") activeQuery = `&active=true`;
      else if (trimmed === "deactivate") activeQuery = `&active=false`;
      else if (trimmed === "true" || trimmed === "false")
        activeQuery = `&active=${trimmed}`;
    } else if (typeof active === "boolean") {
      activeQuery = `&active=${active}`;
    }

    if (search && search.trim()) {
      searchQuery = `&search=${encodeURIComponent(search.trim())}`;
    }

    if (sortColumn && sortDirection) {
      sortQuery = `&sortColumn=${sortColumn}&sortDirection=${sortDirection}`;
    }

    const partyQuery = `&partyRecordType=${encodeURIComponent(partyRecordType)}`;

    return this.http
      .get<{ message: string; data: any }>(
        `${this.BACKEND_URL}/get_Allapplicants?name=${name}${activeQuery}${searchQuery}${partyQuery}${this.roleQuery}&page=${page}&limit=${limit}${sortQuery}`
      )
      .pipe(
        map((Data) => ({
          data: Data.data.map((data) => data),
        }))
      );
  }

  /** Toolbar global search only: lean rows, configurable limit (max 50). Does not affect list/grid `/get_Allapplicants`. */
  searchApplicantsForToolbar(
    search: string,
    limit: number = 25
  ): Observable<{ data: any[] }> {
    const lim = Math.min(Math.max(limit, 1), 50);
    const q = encodeURIComponent((search || "").trim());
    return this.http
      .get<{ status: string; data: any[] }>(
        `${this.BACKEND_URL}/search_applicants_toolbar?search=${q}&limit=${lim}${this.roleQuery}`
      )
      .pipe(
        map((res) => ({
          data: Array.isArray(res.data) ? res.data : [],
        }))
      );
  }

  getAll(
    name: string,
    active: any,
    search: any,
    page: number,
    limit: number,
    sortColumn: string = "",
    sortDirection: "asc" | "desc" | "" = ""
  ): Observable<{ subordinate: any[] }> {
    const roleName = this.Auth.getRoleName();
    const roleQuery = roleName
      ? `&roleName=${encodeURIComponent(roleName)}`
      : "";

    let searchQuery = "";
    let activeQuery = "";
    let sortQuery = "";

    if (typeof active === "boolean") {
      activeQuery = `&active=${active}`;
    } else if (typeof active === "string") {
      activeQuery = `&active=${active.toLowerCase()}`;
    }

    if (search && search.trim()) {
      searchQuery = `&search=${search.trim()}`;
    }

    if (sortColumn && sortDirection) {
      sortQuery = `&sortColumn=${sortColumn}&sortDirection=${sortDirection}`;
    }

    return this.http
      .get<{ message: string; data: any }>(
        `${this.BACKEND_URL}/getAll/users?name=${name}${activeQuery}${searchQuery}${roleQuery}&page=${page}&limit=${limit}${sortQuery}`
      )
      .pipe(
        map((Data) => ({
          subordinate: Data.data.map((data) => data),
        }))
      );
  }

  getUpdateListener4() {
    return this.dataUpdate4.asObservable();
  }

  // dueDate
  getAllDueDates() {
    return this.http.get<{ message: string; data: any }>(
      `${this.BACKEND_URL}/get_dueDates?name=Get All Due Dates${this.roleQuery}`
    );
  }

  updateDueDate(
    history: any,
    record: any,
    record_review: any,
    editing: any,
    finalize: any,
    submitReport: any,
    finalizeBill: any,
    submitBill: any,
    id: string
  ): Observable<{ message: string; data: any }> {
    let data = {
      history,
      record,
      record_review,
      editing,
      finalize,
      submitReport,
      finalizeBill,
      submitBill,
    };
    return this.http.post<{ message: string; data: any }>(
      this.BACKEND_URL +
        "/update_dueDate/" +
        id +
        `?name=Update Due Date${this.roleQuery}`,
      data
    );
  }

  updateDueDate2(
    history1: any,
    record1: any,
    record_review1: any,
    editing1: any,
    finalize1: any,
    submitReport1: any,
    finalizeBill1: any,
    submitBill1: any,
    id: string
  ): Observable<{ message: string; data: any }> {
    let data = {
      history1,
      record1,
      record_review1,
      editing1,
      finalize1,
      submitReport1,
      finalizeBill1,
      submitBill1,
    };
    return this.http.post<{ message: string; data: any }>(
      this.BACKEND_URL +
        "/update_dueDate/" +
        id +
        `?name=Update Due Date${this.roleQuery}`,
      data
    );
  }

  updateDueDate3(
    record2: any,
    record_review2: any,
    editing2: any,
    finalize2: any,
    submitReport2: any,
    finalizeBill2: any,
    submitBill2: any,
    id: string
  ): Observable<{ message: string; data: any }> {
    let data = {
      record2,
      record_review2,
      editing2,
      finalize2,
      submitReport2,
      finalizeBill2,
      submitBill2,
    };

    return this.http.post<{ message: string; data: any }>(
      this.BACKEND_URL +
        "/update_dueDate/" +
        id +
        `?name=Update Due Date${this.roleQuery}`,
      data
    );
  }

  updateDueDate4(
    record3: any,
    record_review3: any,
    editing3: any,
    finalize3: any,
    submitReport3: any,
    finalizeBill3: any,
    submitBill3: any,
    id: string
  ): Observable<{ message: string; data: any }> {
    let data = {
      record3,
      record_review3,
      editing3,
      finalize3,
      submitReport3,
      finalizeBill3,
      submitBill3,
    };

    return this.http.post<{ message: string; data: any }>(
      this.BACKEND_URL +
        "/update_dueDate/" +
        id +
        `?name=Update Due Date${this.roleQuery}`,
      data
    );
  }
  // notification trigger
  getAllNotification() {
    if (this.configService.areNotificationsDisabled()) {
      return of({ message: "Notifications disabled", data: [] });
    }
    return this.http.get<{ message: string; data: any }>(
      `${this.BACKEND_URL}/getAll_Notification_trigger?name=Get All Notification Trigger${this.roleQuery}`
    );
  }

  getAllDepositionNotification() {
    if (this.configService.areNotificationsDisabled()) {
      return of({ message: "Notifications disabled", data: [] });
    }
    return this.http.get<{ message: string; data: any }>(
      `${this.BACKEND_URL}/getAll_DepositionNotification_trigger`
    );
  }

  createNotificationTrigger(
    triggers: any
  ): Observable<{ message: string; data: any }> {
    if (this.configService.areNotificationsDisabled()) {
      return of({ message: "Notifications disabled", data: null });
    }
    return this.http.post<{ message: string; data: any }>(
      this.BACKEND_URL +
        `/createNotification_trigger?name=Add Notification Trigger${this.roleQuery}`,
      triggers
    );
  }

  createDepositionNotificationTrigger(
    triggers: any
  ): Observable<{ message: string; data: any }> {
    if (this.configService.areNotificationsDisabled()) {
      return of({ message: "Notifications disabled", data: null });
    }
    return this.http.post<{ message: string; data: any }>(
      this.BACKEND_URL + `/createDepositionNotification_trigger`,
      triggers
    );
  }
}
